<template>
  <vuex-table
    :fields="fields"
    :show_per_page="false"
    :auto_start="false"
    table_store="mailer/archived_stats/detailed"
  >
    <template slot="body" slot-scope="{ item }">
      <div class="d-inline-block text-truncate" style="max-width: 350px">
        {{ item.body }}
      </div>
    </template>

    <template slot="state" slot-scope="{ formatted: value }">
      <status-badge :value="value" />
    </template>
  </vuex-table>
</template>

<script>
  import StatusBadge from '@mailer/components/messages/messages-badge-state';
  import { toAccountTimezoneDateWithTime } from '@shared/helpers/date_format';

  export default {
    components: { StatusBadge },
    computed: {
      fields: function () {
        return [
          {
            key: 'id',
            label: this.$t('shared.component.table.field.id'),
            sortable: false,
            class: 'column-sticky',
            thStyle: {
              minWidth: '160px'
            }
          },

          {
            key: 'mailing',
            label: this.$t('mailer.stats.general.filter.sender.title'),
            formatter: (mailing) => mailing?.sender
          },

          {
            key: 'number',
            label: this.$t('mailer.message.field.dst'),
            sortable: false,
            thStyle: {
              minWidth: '190px'
            }
          },

          {
            key: 'created_at',
            label: this.$t('mailer.message.field.created_at'),
            sortable: true,
            class: 'table-created_at',
            formatter: (value) => (value ? toAccountTimezoneDateWithTime(value) : ''),
          },

          {
            key: 'body',
            label: this.$t('mailer.message.field.body'),
            sortable: false
          },

          {
            key: 'state',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            thStyle: {
              minWidth: '120px'
            }
          },

          {
            key: 'total_parts',
            label: this.$t('mailer.message.field.parts'),
            sortable: false,
            thStyle: {
              maxWidth: '100px'
            }
          },

          {
            key: 'client_cost',
            label: this.$t('mailer.stats.general.field.cost'),
            sortable: false,
            thStyle: {
              minWidth: '130px'
            },

            formatter: (val) => this.$numeral.currency(val)
          }
        ];
      }
    }
  };
</script>